// extracted by mini-css-extract-plugin
export default {"bottom-sheet-button":"VNwgscq2osQKlkopPFcf","bottom-sheet-content":"kTpUvZ0K7EFikVCxO6AK","bottom-sheet-guide-msg":"jiQhRQ64RVq8M6qmHQIK","bullet":"c23Fee5wrKELKZecn8QN"};